import {useContext } from "react";
import { MlVectorTileLayer } from "@mapcomponents/react-maplibre";
import config from "../config";
import { DataContext } from "../context/DataContext";
import { useTheme } from "@mui/material/styles";
import {defaultTheme} from "../index";


export default function ProtectedAreas() {
  const dataContext = useContext(DataContext);
  const theme = useTheme(defaultTheme);

   const layerConfigs = () => {
    const layerConfig = [{
      id:"protectedAreas_fill",
          type: "fill",
          "source-layer": "schutzgebiete",
          paint: {
            "fill-color": theme.palette.layers?.protectedAreas,
            "fill-opacity": dataContext.protectedAreaHidden ? 0 : dataContext.protecteAreasOpacity,
          },
          layout: {
            "visibility": dataContext.protectedAreaHidden ? "none": "visible"
          },
           maxzoom: 22,
           minzoom: 8,
        }, {
            id:"protecterdAreas_line",
            type: "symbol",
            "source-layer": "schutzgebiete",
            paint: { "text-opacity": dataContext.protecteAreasOpacity },
            layout: {
                "visibility": !dataContext.protectedAreaHidden && dataContext.protecteAreasLabels ? "visible" : "none",             
                "text-field": [
                  "case",
                  ["==", ["get", "type"], "Fauna_Flora_Habitat_Gebiete"], "Fauna Flora Habitat Gebiete",
                  ["==", ["get", "type"], "Nationale_Naturmonumente"], "Nationale Naturmonumente",
                  ["get", "type"]
                ],
                "text-font": ["Klokantech Noto Sans Regular"],
            },
             maxzoom: 22,
             minzoom: 11,
        }
    ];
   
    return layerConfig;
  };

   

  return (
    <>
      <MlVectorTileLayer
        mapId="map_1"
        layerId="Schutzgebiete"
        url={
          config.tileServerHost +
          "tileservergl/data/schutzgebiete/{z}/{x}/{y}.pbf?"
        }
        insertBeforeLayer="GLöZ2_areas_fill"       
        sourceOptions={{ attribution: "© Bundesamt für Naturschutz- Stand der Daten: 2024", 
            maxzoom: 16, minzoom: 8 }}
        layers={layerConfigs()}
      />
    </>
  );
}
